import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'lum-channel-custom-fields',
  templateUrl: './channel-custom-fields.component.html',
  styleUrls: ['./channel-custom-fields.component.scss'],
})
export class ChannelCustomFieldsComponent implements OnInit, OnDestroy {
  @Input()
  form :UntypedFormGroup;

  private readonly onDestroy$ = new Subject();
  constructor(private fb :UntypedFormBuilder) {}

  ngOnInit() :void {}

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onAddCustomField() :void {
    const newGroup = this.fb.group({
      key: [null],
      value: [null],
    });

    // Flag to prevent infinite loop
    let updating = false;

    const handleValueChange = () => {
      if (updating) return; // Exit if already updating to avoid infinite loop

      updating = true;
      this.updateValidators(newGroup);
      updating = false;
    };

    // Subscribe to changes in both fields
    newGroup
      .get('key')
      .valueChanges.pipe(takeUntil(this.onDestroy$))
      .subscribe(handleValueChange);
    newGroup
      .get('value')
      .valueChanges.pipe(takeUntil(this.onDestroy$))
      .subscribe(handleValueChange);

    this.pushCustomFieldsControl.push(newGroup);
    this.form.updateValueAndValidity();
  }

  onRemoveCustomField(index :number) :void {
    this.pushCustomFieldsControl.removeAt(index);
  }

  private updateValidators(group :UntypedFormGroup) :void {
    const keyField = group.get('key');
    const valueField = group.get('value');

    if (keyField.value.trim() !== '' || valueField.value.trim() !== '') {
      keyField.setValidators([Validators.required]);
      valueField.setValidators([Validators.required]);
    } else {
      keyField.clearValidators();
      valueField.clearValidators();
    }

    keyField.updateValueAndValidity({ emitEvent: false });
    valueField.updateValueAndValidity({ emitEvent: false });
  }

  get pushCustomFieldsControl() :UntypedFormArray {
    return this.form?.get(
      'pushOrdersToOmsOptions.pushCustomFields',
    ) as UntypedFormArray;
  }
}
